import React from 'react';
import { useWindowDimensions } from "../../../utils";
import { OnestSemiBoldMed, OnestNormalSmall } from '../../styled/TextComponents';
import {Button} from '../../controls/Button/Button';
import { color_white, color_black_ultra_light, color_grey_dark } from '../../../constants/colors';





const OptionTile = ({ titleText, text, buttonText, imgName, buttonOnClick, baseWidth }) => {
    const { height: screenHeight, width: screenWidth } = useWindowDimensions();

    return (
        <div style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            padding: 24,
            //150+240
            //width: screenWidth > 1420 ? ((screenWidth - 378 - 23) / 3) - 40 : (screenWidth > 990 ? ((screenWidth - 150 - 60) / 3)- 40 : screenWidth - 98),
            width: screenWidth > 1280 ? (baseWidth / 3) - 60 : (screenWidth > 990 ? ((screenWidth - 150 - 60) / 3)- 40 : screenWidth - 98),
            minHeight: 186 - 24,
            gap: 10,
            backgroundColor: color_white,
            borderRadius: 16,
        }}>
            <OnestSemiBoldMed style={{ marginBottom: 0 }} >
                {titleText}
            </OnestSemiBoldMed>
            <OnestNormalSmall style={{ color: color_black_ultra_light, width: 200 }}>
                {text}
            </OnestNormalSmall>
            <Button
                color={color_black_ultra_light}
                backgroundColor={color_white}
                borderColor={color_grey_dark}
                style={{
                    width: 192,
                    height: 40,
                    marginTop: "auto",
                    padding: 8,
                    borderRadius: 15,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: screenWidth > 800 ? 0 : 16,
                    zIndex: 3,
                }}
                onClick={buttonOnClick}
            >
                {buttonText}
            </Button>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    alignSelf: "flex-end",
                    justifyContent: "space-between",
                    position: screenWidth > 440 ? "absolute" : "relative",
                    marginRight: screenWidth > 440 ? 0 : -24,
                    marginBottom: screenWidth > 440 ? 0 : -24,
                    bottom: 0,
                    right: 0,
                    borderRadius: 16,
                    backgroundImage: `url(${process.env.PUBLIC_URL}/${imgName}.png)`,
                    backgroundSize: "cover",
                    width: 130,
                    height: 106,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "right bottom",
                }}>
            </div>
        </div>
    )
}

export default OptionTile;